import React, {useEffect, useState} from 'react';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { withRouter } from "react-router";
import { Redirect } from "react-router-dom";
import {Copyright} from '../../../components';
import { useFormik } from 'formik';
import {loginUser, registerUser} from '../../../services/auth.service';
import { useAuth } from "../../../context/auth";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import PoweredbyDQ from "../../../assets/images/PoweredByDQ_Default.png"
import 'aos/dist/aos.css'
import AOS from 'aos'
import Box from "@material-ui/core/Box";
import {LOCAL_STORAGE_KEYS} from "../../../utils/constants";
import * as uuid from "uuid";

const useStyles = makeStyles((theme) => ({
    paper: {
        background: theme.palette.background.default,
        color: theme.palette.loginPage.text,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent:'center',
        textAlign:'center',
        fontFamily:'Surt',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    section1: {
        height:'100vh',
        fontFamily:'Surt',
        '@media (min-width: 768px) and (max-width: 960px)': {
            height:'75%',
        },
        '@media (min-width: 960px) and (max-width: 1024px)': {
            height:'40%',
        },
    },

}));

const GuestLogin = (props) => {
    const classes = useStyles();
    const { setAuthToken, setAuthUser } = useAuth();
    const referer = props.location.referer || '/home';
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        AOS.init({
            duration: 500,
        });
        loginAsGuest();
    }, []);

    const loginAsGuest = async () => {
        setLoading(true);

        let guestFingerprint = localStorage.getItem(LOCAL_STORAGE_KEYS.guest_fingerprint);
        if (!guestFingerprint) {
            const userPart = uuid.v4();
            const passPart = uuid.v4();
            guestFingerprint = `${userPart}::${passPart}::false`;
            localStorage.setItem(LOCAL_STORAGE_KEYS.guest_fingerprint, guestFingerprint);
        }

        // extract the username and password from the fingerprint
        const fingerprintParts = guestFingerprint.split('::');
        const email = fingerprintParts[0];
        const password = fingerprintParts[1];
        const registered = fingerprintParts[2] === 'true';


        // auto login logic
        if (registered) {
            try {
                const result = await loginUser(email, password, true);
                if (result.data && result.data.user) {
                    await setAuthToken(result.data.auth_token);
                    await setAuthUser(result.data.user);
                    localStorage.setItem(LOCAL_STORAGE_KEYS.refresh_token, JSON.stringify(result.data.refresh_token));
                }
                setLoading(false);
            } catch (e) {
                // already toasted the error
                setLoading(false);
            }
        } else {
            // auto register logic
            try {
                const result = await registerUser(email, password, true, true);
                if (result.data && result.data.user) {
                    await setAuthToken(result.data.auth_token);
                    await setAuthUser(result.data.user);
                    localStorage.setItem(LOCAL_STORAGE_KEYS.refresh_token, JSON.stringify(result.data.refresh_token));

                    const updaterGuestFingerprint = `${email}::${password}::true`;
                    localStorage.setItem(LOCAL_STORAGE_KEYS.guest_fingerprint, updaterGuestFingerprint);
                }
                setLoading(false);
            } catch (e) {
                // already toasted the error
                setLoading(false);
            }
        }

        return <Redirect to={referer} />;
    }


    return (
        <>
            <div>
                <Grid container className={classes.section1} data-aos="fade-in" data-aos-delay='100'>
                    <Grid item xs={12} md={12} style={{marginTop:'auto'}}>
                        <Container component="main" maxWidth="sm">
                            <div className={classes.paper} style={{
                                marginTop: '40px',
                                paddingBottom: '50px',
                            }}>
                                <img src={PoweredbyDQ} alt="Image"
                                     style={{
                                         width:'300px',
                                         cursor: 'pointer'
                                     }}/>

                                <Grid item style={{textAlign: 'center', fontFamily: 'Surt', color: '#000'}}>
                                    <Link href="#" variant="body2">
                                        {"Logging in as a guest, Please wait..."}
                                    </Link>
                                </Grid>
                            </div>

                            <LoaderWithBackDrop loading={loading}/>
                        </Container>
                    </Grid>
                    <Box mt={7} style={{display:'flex', alignItems:'center', justifyContent:'center', width:'100%',}}>
                        <Copyright />
                    </Box>
                </Grid>
            </div>
        </>
    );
}

export default withRouter(GuestLogin);